import { Course, Genre, MenuBook } from '../../models';
import MenuRowList from '../MenuRowList';
import SubGenreRow from '../SubGenreRow';

export interface SubGenreRowListProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
}

function SubGenreRowList({ menuBook, course, genre }: SubGenreRowListProps) {
  return (
    <>
      {genre.subgenres.map((subgenre) => (
        <SubGenreRow
          key={`subgenre-${subgenre.id}`}
          menuBook={menuBook}
          course={course}
          genre={genre}
          subgenre={subgenre}
        >
          <MenuRowList menuBook={menuBook} course={course} genre={genre} subgenre={subgenre} />
        </SubGenreRow>
      ))}
    </>
  );
}

export default SubGenreRowList;
